export default "__VITE_ASSET__064cca98__"